import React, { useContext, } from 'react';
import { Card, CardBody, Stat, StatLabel, StatNumber, StatHelpText, Flex, Box } from '@chakra-ui/react'
import { ChevronRightIcon } from './assets/chevron-right';
import { Link as RouterLink } from "react-router-dom";

import { HIDDEN_OBS_VARIABLES } from '../../utils/constants';
import {
    getParameterDisplayName,
    getLatestObservation,
    getRelativeTime,
    getParameterTrend,
    getParameterUnit,
    getObservationInPreferredUnits
} from '../../utils/helpers';
import { ParameterTrend } from './ParameterTrend';
import { CardinalDirectionIndicator } from '../CardinalDirectionIndicator';
import { PreferredUnitsContext } from '../contexts/PreferredUnitsContext';
import Observation from './Observation';

const StationDataComponent = (props) => {
    const { stationObservations, stationMetadata, datasetId } = props;
    const [preferredUnitSystem] = useContext(PreferredUnitsContext);

    const singleObservation = stationObservations[0];
    const latestObservations = [];

    // setup latest observations for each variable the station has
    for (const variable in singleObservation) {
        if (!HIDDEN_OBS_VARIABLES.includes(variable)) {
            const displayName = getParameterDisplayName(stationMetadata, variable);
            // get the latest observation for the given parameter, because sometimes 
            // not every variable has an observation value at the a given time
            const latestObs = getLatestObservation(stationObservations, variable);
            const trend = getParameterTrend(stationObservations, variable);

            if (latestObs) {
                const parameterUnit = getParameterUnit(stationMetadata, variable);
                const observation = getObservationInPreferredUnits(variable, latestObs[variable], parameterUnit, preferredUnitSystem);
                const timestamp = latestObs.time;
                latestObservations.push({
                    time: getRelativeTime(timestamp),
                    standardName: variable,
                    displayName: displayName,
                    value: observation?.value,
                    unit: observation?.unit,
                    trend: trend,
                });
            }
        }
    };

    return (
        <Box pt={4} bg={'gray.100'}>
            {latestObservations.map((observation, index) => (
                <Card key={index} margin={'0px 10px 10px 10px'}>
                    <CardBody>
                        <RouterLink to={`/stations/${datasetId}/${observation.standardName}`}>
                            <Stat>
                                <StatLabel textAlign='left'>{observation.displayName}</StatLabel>
                                <Flex justifyContent={'space-between'}>
                                    <Flex alignItems={'center'}>
                                        <StatNumber>
                                            <Observation value={observation.value} unit={observation.unit} />
                                        </StatNumber>
                                        {observation.unit === '°' &&
                                            <CardinalDirectionIndicator degrees={observation.value} directionSize={20} arrowSize={30} />
                                        }
                                    </Flex>
                                    <ChevronRightIcon />
                                </Flex>
                                <StatHelpText>
                                    <Flex alignItems='center'>
                                        {observation.trend && <ParameterTrend trend={observation.trend} />}
                                        {observation.time}
                                    </Flex>
                                </StatHelpText>
                            </Stat>
                        </RouterLink>
                    </CardBody>
                </Card>
            ))}
        </Box>
    )
};

export const StationData = React.memo(StationDataComponent);
